import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import { useGetLiabilityAccountsByCompanyQuery, useGetAllcompanyQuery } from "../../../../store/api/supplier";

const Table = ({ setSelectedCompanyAccounts }) => {
    const [company, setCompany] = useState([]);
    const [accountsCache, setAccountsCache] = useState({}); // Cache for company accounts

    const createNewRow = () => ({
        company: "",
        default_account: ""
    });

    const tableRef = useRef();
    const dropdownRef = useRef();
    const [rowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [rows, setRows] = useState([createNewRow()]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showDropdownIndex, setShowDropdownIndex] = useState(null);
    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
    const [selectedCompanyForApi, setSelectedCompanyForApi] = useState(null);

    const { data: companyData } = useGetAllcompanyQuery();
    const { data: accountsData } = useGetLiabilityAccountsByCompanyQuery(selectedCompanyForApi, {
        skip: !selectedCompanyForApi
    });

    useEffect(() => {
        if (companyData) {
            setCompany(companyData?.data || []);
        }
    }, [companyData]);

    useEffect(() => {
        if (accountsData && focusedCell.rowIndex !== null && selectedCompanyForApi) {
            setAccountsCache(prev => ({
                ...prev,
                [selectedCompanyForApi]: accountsData.data
            }));

            const updatedRows = [...rows];
            updatedRows[focusedCell.rowIndex].default_account =
                accountsData.data[0]?.name || 'No account found';
            setRows(updatedRows);
        }
    }, [accountsData]);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((_, index) => index));
        } else {
            setSelectedRows([]);
        }
    };

    const toggleRowSelection = (index) => {
        setSelectedRows(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const updateRow = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleAddRow = () => {
        setRows([...rows, createNewRow()]);
        const lastPage = Math.ceil((rows.length + 1) / rowsPerPage);
        if (currentPage !== lastPage) setCurrentPage(lastPage);
    };

    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) setCurrentPage(lastPage);
    };

    const handleCompanySelect = (rowIndex, selectedCompany) => {
        const companyName = selectedCompany.name;

        // Check cache first
        if (accountsCache[companyName]) {
            const updatedRows = [...rows];
            updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                company: companyName,
                default_account: accountsCache[companyName][0]?.name || 'No account found'
            };
            setRows(updatedRows);
        } else {
            // Not in cache, set loading and trigger API call
            const updatedRows = [...rows];
            updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                company: companyName,
                default_account: 'Loading...'
            };
            setRows(updatedRows);
            setSelectedCompanyForApi(companyName);
        }

        setFocusedCell({ rowIndex, field: 'company' });
        setShowDropdownIndex(null);
    };

    useEffect(() => {
        const filtered = rows
            .filter(row => row.company && row.default_account)
            .map(row => ({
                company: row.company,
                account: row.default_account
            }));
        setSelectedCompanyAccounts(filtered);
    }, [rows]);

    return (
        <div className="table-container">
            <table className="table table-bordered mb-1" ref={tableRef}>
                <thead className="tableHead1">
                    <tr>
                        <th style={{ width: '4%', textAlign: 'center' }}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                style={{
                                    backgroundColor: isAllSelected ? "#270b79" : "",
                                    borderColor: isAllSelected ? "#270b79" : ""
                                }}
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                            />
                        </th>
                        <th style={{ width: '4%', textAlign: 'center' }}>S.No</th>
                        <th style={{ width: '350px' }}>Company</th>
                        <th style={{ width: '350px' }}>Default Account</th>
                        <th style={{ width: '250px', textAlign: 'center' }}>
                            <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentRows.map((row, index) => {
                        const globalIndex = indexOfFirstRow + index;
                        return (
                            <tr key={globalIndex} style={{ height: '25px' }}>
                                <td className="p-0" style={{ cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input "
                                        style={{
                                            backgroundColor: selectedRows.includes(globalIndex) ? "#270b79" : "",
                                            borderColor: selectedRows.includes(globalIndex) ? "#270b79" : ""
                                            , marginTop: '8px'
                                        }}
                                        checked={selectedRows.includes(globalIndex)}
                                        onChange={() => toggleRowSelection(globalIndex)}
                                    />
                                </td>
                                <td style={{ textAlign: "center" }}><span style={{ fontSize: '0.8rem' }}
                                >{globalIndex + 1}</span></td>
                                <td className="p-0 position-relative " style={{ textAlign: "center" }}>
                                    <input
                                        type="text"
                                        placeholder="Company"
                                        style={{ textAlign: "center", fontSize: '0.8rem' }}
                                        className="form-control tableinput noborder"
                                        value={row.company}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'company' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "company", e.target.value)}
                                    />
                                    {showDropdownIndex === globalIndex && (
                                        <div
                                            ref={dropdownRef}
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {company
                                                .filter(c => c.name.toLowerCase().includes(row.company?.toLowerCase()))
                                                .map((comp) => (
                                                    <button
                                                        key={comp.id}
                                                        className="dropdown-item"
                                                        type="button"
                                                        style={{ fontSize: '0.8rem' }}
                                                        onClick={() => handleCompanySelect(globalIndex, comp)}
                                                    >
                                                        {comp.name}
                                                    </button>
                                                ))}
                                        </div>
                                    )}
                                </td>
                                <td className="p-0">
                                    <input
                                        type="text"
                                        placeholder="Default Account"
                                        style={{ textAlign: "center", fontSize: '0.8rem' }}
                                        className="form-control tableinput noborder"
                                        value={row.default_account}
                                        readOnly
                                    />
                                </td>
                                <td className="p-0" >
                                    <GetIcon iconName="MdOutlineEdit" size={15} style={{ marginTop: '6px' }} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className="d-flex pb-2 justify-content-between align-items-center">
                <div className="d-flex" style={{ gap: '4px' }}>
                    {selectedRows.length > 0 && (
                        <Button
                            onClick={handleDeleteSelectedRows}
                            className="customdeletebtn"
                            iconName="MdDeleteOutline"
                        >
                            Delete
                        </Button>
                    )}
                    <Button
                        onClick={handleAddRow}
                        className="Addrowdesign"
                        iconName="FiPlus"
                        iconSize={12}
                        iconWrapperStyle={{ backgroundColor: '#ff8d5c', padding: '1px', display: 'flex' }}
                    >
                        Add Row
                    </Button>
                    <Button
                        className="createbtn d-flex"
                        iconName="MdOutlineFileDownload"
                        style={{ height: '28px' }}
                    >
                        Download
                    </Button>
                </div>

                {rows.length > 10 && (
                    <>
                        <div className="d-flex align-items-center centerpagination">
                            <Pagination
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                pageSize={rowsPerPage}
                                totalrecords={rows.length}
                            />
                        </div>
                        <div className="d-flex">
                            <span className="px-2" style={{ color: '#270B79' }}>
                                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Table;